import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { MyMenuAsk, MyMenuEvent, MyMenuGiftDetail, MyMenuItemDetail, MyMenuMemModify, MyMenuMessage } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import { useRouter } from 'next/navigation';
import { AllMenuContainer } from './all/AllMenuContainer';
export default function AfterASPMenuItems() {
  const $ = _c(39);
  const router = useRouter();
  const {
    userInfo
  } = useGetLoginInfoQuery();
  const isPostAllowed = SettingConfig?.aspUtils?.aspInfo?.postYN === "Y" && userInfo?.purchaseUser === "Y";
  let t0;
  if ($[0] !== router) {
    t0 = () => router.push("/my/heart/used");
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MyMenuGiftDetail className="w-[20px]" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className="item"><DropdownMenuItem className="text-[15px] text-box" onClick={t0}>{t1}하트내역</DropdownMenuItem></div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isPostAllowed || $[6] !== router) {
    t3 = isPostAllowed && <div className="item"><DropdownMenuItem className="text-[15px] text-box" onClick={() => router.push("/my/post/received")}><MyMenuMessage className="w-[20px]" />쪽지</DropdownMenuItem></div>;
    $[5] = isPostAllowed;
    $[6] = router;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== router) {
    t4 = () => router.push("/my/item/used");
    $[8] = router;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MyMenuItemDetail className="w-[20px]" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="item"><DropdownMenuItem className="text-box" onClick={t4}>{t5}아이템내역</DropdownMenuItem></div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== router) {
    t7 = () => router.push("/my/modify");
    $[13] = router;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <MyMenuMemModify className="w-[20px]" />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7) {
    t9 = <div className="item"><DropdownMenuItem className="text-box" onClick={t7}>{t8}회원정보수정</DropdownMenuItem></div>;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t6 || $[21] !== t9) {
    t10 = <AllMenuContainer title={"\uB9C8\uC774\uD398\uC774\uC9C0"} isbottom={true}>{t2}{t3}{t6}{t9}</AllMenuContainer>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== router) {
    t11 = () => router.push("/customer/event?page=1");
    $[23] = router;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <MyMenuEvent className="w-[20px]" />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11) {
    t13 = <div className="item"><DropdownMenuItem className="text-[15px] text-box" onClick={t11}>{t12}이벤트</DropdownMenuItem></div>;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== router) {
    t14 = () => router.push("/customer/inquire");
    $[28] = router;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MyMenuAsk className="w-[20px]" />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14) {
    t16 = <div className="item"><DropdownMenuItem className="text-box" onClick={t14}>{t15}1:1문의</DropdownMenuItem></div>;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t13 || $[34] !== t16) {
    t17 = <AllMenuContainer title={"\uACE0\uAC1D\uC13C\uD130"} isbottom={true}>{t13}{t16}</AllMenuContainer>;
    $[33] = t13;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t10 || $[37] !== t17) {
    t18 = <>{t10}{t17}</>;
    $[36] = t10;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
}